import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { IUser, IUserSecurity, UserAccountStatus } from '../../shared/models/user.interface';

export const UserActions = createActionGroup({
  source: 'User',
  events: {
    loadUser: emptyProps(),
    loadUserFail: props<{ error: Error }>(),
    loadUserSuccess: props<{ user: IUser; security: IUserSecurity; accountStatus: UserAccountStatus }>(),
  },
});
